var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":"Is base product ?","false-value":0,"true-value":1},model:{value:(_vm.model.baseProduct),callback:function ($$v) {_vm.$set(_vm.model, "baseProduct", $$v)},expression:"model.baseProduct"}})}
var staticRenderFns = []

export { render, staticRenderFns }